/*globals Mustache */
'use strict';
import Mustache from 'mustache';

const fiksudiiliCalc = {
  templates: {},
  containers: {},
  settings: {},
  init: function() {
    if (document.getElementById('auto-fiksudiili-calculator')) {
      this.templates['fd-kilometers'] = document.getElementById('mustache-auto-fd-kilometers').innerText;
      this.templates['fd-optional'] = document.getElementById('mustache-auto-fd-optional').innerText;

      this.templates['fd-slider'] = document.getElementById('mustache-auto-fd-kilometers-slider').innerText;
      this.templates['fd-slider-btn'] = document.getElementById('mustache-auto-fd-kilometers-slider-btn').innerText;

      this.containers['fd-kilometers'] = document.getElementById('fiksudiili-kilometers');
      this.containers['fd-payments'] = document.getElementById('fiksudiili-periods');
      this.containers['fd-optional'] = document.getElementById('fiksudiili-optional');
      this.containers['fd-price'] = document.getElementById('fd-price');
      this.containers['fd-price-big'] = document.getElementById('fd-price-big');

      this.settings = {};
      for (const [period, kilometers] of Object.entries(window.fdData)) {
        this.settings[period] = Object.keys(kilometers).map(Number);
      }
      this.containers['fd-kilometers'].addEventListener('input', this.kilometersInputHandler.bind(this));
      this.containers['fd-payments'].addEventListener('click', this.paymentsClickHandler.bind(this));
      this.containers['fd-optional'].addEventListener('click', this.renderPrice.bind(this));

      this.preselect();

      this.sessionOptions = {};
      for (const checkOption of ['huoltosopimus', 'rengassailytys']) {
        const presetValue = sessionStorage.getItem(`fiksudiiliChoice-${checkOption}`);
        this.sessionOptions[checkOption] = presetValue && presetValue === 'true';
      }

      this.renderSelections();
      this.containers['fd-option-service'] = document.getElementById('fd-option-huoltosopimus');

      this.renderPrice();
    }
  },

  preselect: function() {
    const [sessionPms, sessionKms] = String(sessionStorage.getItem('fiksudiiliDuration')).split('_');

    const kilometers = Number(sessionKms) || 40;
    this.payments = Number(sessionPms) || 48;
    this.render(kilometers);
    this.kilometers = kilometers;
    const colorElement = document.querySelector('#fiksudiili-colors [value="white"]');

    if (colorElement) {
      colorElement.setAttribute('checked', true);
    }
  },

  render: function(kilometers) {
    this.renderSlider(this.settings[this.payments], kilometers);
  },

  renderSlider: function(kilometers, selectedKilometers) {
    const sliderLabels = [];
    kilometers.map(km => sliderLabels.push({ key: km, label: `${km} tkm` }));

    this.containers['fd-kilometers'].innerHTML = Mustache.render(
      this.templates['fd-slider'],
      {
        labels: sliderLabels,
        labelsJSON: JSON.stringify(sliderLabels),
        button: {
          customClass: 'flex-icon-button pad-button',
          id: 'sliderbtn',
          label: '❮ <span class="target"></span> ❯',
          primary: true,
          sublabel: '',
          flex: false,
        },
        steps: sliderLabels.length - 1,
        customClass: 'fiksudiili-slider',
        fieldName: 'fd-kilometers-slider',
        initialValue: selectedKilometers,
      },
      { button: this.templates['fd-slider-btn'] },
    );
  },

  renderSelections: function() {
    let price = window.fdData[this.payments][this.kilometers];

    if (typeof price === 'undefined') {
      price = window.fdData[48][40];
    }

    const options = {
      optional: [
        {
          id: 'rengassailytys',
          label: 'Rengassäilytys',
          price: window.fdTyreFee,
          checked: this.sessionOptions['rengassailytys'],
        },
        {
          id: 'huoltosopimus',
          label: 'Huoltopalvelu',
          price: price.pricePlus, // This is individual for each selection
          checked: this.sessionOptions['huoltosopimus'],
        },
      ],
    };
    this.initialPrice = options.optional.reduce((sum, option) => (option.checked && option.price) + sum, 0);
    this.containers['fd-optional'].innerHTML = Mustache.render(this.templates['fd-optional'], options);
  },

  renderPrice: () => {
    const periods = fiksudiiliCalc.payments;
    const kilometers = fiksudiiliCalc.kilometers;
    const price = window.fdData[periods][kilometers];

    sessionStorage.setItem('fiksudiiliDuration', `${periods}_${kilometers}`);
    fiksudiiliCalc.servicePrice = price ? price.pricePlus : 0;
    fiksudiiliCalc.price = price ? price.price + fiksudiiliCalc.selectionsPrice : 0;
  },

  kilometersClickHandler: event => {
    if (event.target && event.target.matches('input[type="radio"]')) {
      fiksudiiliCalc.renderPrice();
    }
  },

  kilometersInputHandler: event => {
    fiksudiiliCalc.renderPrice();
  },

  paymentsClickHandler: event => {
    if (event.target && event.target.matches('input[type="radio"]')) {
      fiksudiiliCalc.render();
      fiksudiiliCalc.renderPrice();
    }
  },

  set payments(value) {
    document.querySelectorAll('#fiksudiili-periods label input[type="radio"]').forEach(input => (input.checked = false));
    const input = document.querySelector(`#fiksudiili-periods label input[type="radio"][value="${value}"]`);
    if (input) input.checked = true;
  },

  get payments() {
    const input = document.querySelector('#fiksudiili-periods input[type="radio"]:checked');
    return input ? parseInt(input.value) : 0;
  },

  set kilometers(value) {
    const option = document.querySelector(`#fiksudiili-kilometers select option[value="${value}"]`);
    if (option) option.selected = true;
    const price = window.fdData[fiksudiiliCalc.payments][value];
    fiksudiiliCalc.price = price ? price.price : 0;
  },

  set servicePrice(value) {
    if (this.containers['fd-option-service'].write) {
      this.containers['fd-option-service'].write(value);
    }
  },

  get kilometers() {
    const select = document.querySelector('#fiksudiili-kilometers select');
    return select ? parseInt(select.options[select.selectedIndex].value) : 0;
  },

  set price(value) {
    this.containers['fd-price'].write(value);
    this.containers['fd-price-big'].write(value);
  },

  get selectionsPrice() {
    document.querySelectorAll('#fiksudiili-optional [type="checkbox"]').forEach(option => {
      sessionStorage.setItem(`fiksudiiliChoice-${option.value}`, option.checked);
    });
    let sum = 0;
    try {
      document.querySelectorAll('#fiksudiili-optional [type="checkbox"]:checked + .value .dynamic-number').forEach(option => {
        sum += option.read();
      });
    } catch (e) {
      return fiksudiiliCalc.initialPrice;
    }
    return sum;
  },
};

export default fiksudiiliCalc;
